module.exports = __webpack_public_path__ + "img/antes_despues_102.6fa075e9.png";